/*********************** Boost + Discount Ninja Integration ************************/

if (window.boostSDAppConfig) {
  window.boostSDAppConfig.integration = Object.assign(
    { labels: 'flair' },
    window.boostSDAppConfig.integration || {}
  );
}

// Debounced Okendo reinit
let okendoReinitTimeout = null;
function reinitOkendo() {
  clearTimeout(okendoReinitTimeout);
  okendoReinitTimeout = setTimeout(() => {
    if (window.okeWidgetApi && typeof window.okeWidgetApi.initAllWidgets === 'function') {
      window.okeWidgetApi.initAllWidgets();
    }
  }, 300);
}

// Remove raw Okendo JSON
function cleanOkendoJSON(container) {
  if (!container) return;
  const walker = document.createTreeWalker(container, NodeFilter.SHOW_TEXT, null, false);
  const nodesToRemove = [];
  while (walker.nextNode()) {
    const text = walker.currentNode.textContent.trim();
    if (text.includes('"reviewCount"') || text.includes('"reviewAverageValue"')) {
      nodesToRemove.push(walker.currentNode);
    }
  }
  nodesToRemove.forEach(node => node.remove());
}

/* TEMPORARILY DISABLED - Testing DN with CSS selectors only
// Discount Ninja Integration
function initDiscountNinja(productItem) {
  if (typeof window.discountNinja === 'undefined' || !window.discountNinja.api) {
    setTimeout(() => initDiscountNinja(productItem), 100);
    return;
  }
  
  try {
    const dnAPI = window.discountNinja.api.strikethroughPricing;
    if (dnAPI && typeof dnAPI.apply === 'function') {
      dnAPI.apply(productItem);
      console.log('DN: Applied to product');
      if (typeof dnAPI.render === 'function') {
        dnAPI.render(productItem);
        console.log('DN: Rendered');
      }
    }
  } catch (error) {
    console.error('DN error:', error);
  }
}
*/

// Boost Customization
const customize = {
  updateProductItem: (componentRegistry) => {
    componentRegistry.useComponentPlugin('ProductItem', {
      name: 'Flair + Okendo', // Removed "Discount Ninja" from name
      enabled: true,
      apply: () => ({
        afterRender(element) {
          let productData = element.getParams().props.product;
          let productItem = document.querySelector('.boost-sd__product-item[data-product-id="' + productData.id + '"]');
          
          if (productItem) {
            cleanOkendoJSON(productItem);
            
            let flairEl = productItem.querySelector('[data-flair-product-badge]');
            let imageContainer = productItem.querySelector('.boost-sd__product-image');
            if (flairEl && imageContainer) {
              imageContainer.append(flairEl);
            }
            
            // REMOVED: initDiscountNinja(productItem);
          }
          
          reinitOkendo();
        }
      }),
    });
  }
}

window.__BoostCustomization__ = (window.__BoostCustomization__ ?? []).concat([customize.updateProductItem]);